<script>
import velocity from 'velocity-animate'

export default {
  props: {
    duration: {
      type: String,
      default: '200ms',
    },
  },
  methods: {
    beforeEnter(element) {
      this.setProperty(element)
    },
    enter(element, complete) {
      this.invokeVelocity(element, 'slideDown', complete)
    },
    afterEnter(element) {
      this.removeProperty(element)
    },
    beforeLeave(element) {
      this.setProperty(element)
    },
    leave(element, complete) {
      this.invokeVelocity(element, 'slideUp', complete)
    },
    afterLeave(element) {
      this.removeProperty(element)
    },
    setProperty(element) {
      element.style.setProperty('will-change', 'height')
    },
    removeProperty(element) {
      element.style.removeProperty('will-change')
    },
    invokeVelocity(element, action, complete) {
      const velocityConfig = {
        duration: this.duration,
        easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
      }
      velocity(element, action, velocityConfig, { complete })
    },
  },
  render(createNode) {
    const transitionData = {
      attrs: { name: 'slide' },
      on: {
        enter: this.enter,
        leave: this.leave,
        'after-enter': this.afterEnter,
        'before-enter': this.beforeEnter,
        'before-leave': this.beforeLeave,
        'after-leave': this.afterLeave,
      },
    }
    return createNode('transition', transitionData, this.$slots.default)
  },
}
</script>



// WEBPACK FOOTER //
// src/components/AccordionTransition.vue